import { render, staticRenderFns } from "./RightSection.vue?vue&type=template&id=fd139ac6"
import script from "./RightSection.vue?vue&type=script&lang=js"
export * from "./RightSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports